<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            RELATÓRIO DE ASSINATURAS
          </h4>

          <div class="row">
            <div class="col-6" v-show="tela == 1">
              <BaseFiltroRelatorio
                tipo="basico"
                @pesquisar="pesquisar"
                :btEnviarEmail="false"
              />
            </div>
          </div>

          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                >
                  <i class="tim-icons icon-minimal-left"></i>
                  Voltar
                </base-button>
              </div>

              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i>
                  Imprimir
                </base-button>
              </div>
            </div>

            <!-- Cabeçalho -->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      RELATÓRIO DE ASSINATURAS
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à ${moment(payloadPesquisa.data_final).format(
                          "DD/MM/YYYY",
                        )}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>

                    <div class="col text-left" v-else>
                      DEPARTAMENTO: NENHUM
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>

                    <div class="col text-left" v-else>
                      POSTO DE TRABALHO: NENHUM
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabela de resultados -->
            <div class="table-responsive p-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Início</th>
                    <th scope="col">Fim</th>
                    <th scope="col">Status</th>
                    <th scope="col">Data Geração</th>
                    <th scope="col">Data Assinatura</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="item in dados"
                    :key="`${item.id}-${item.dataGeracao}`"
                  >
                    <th>
                      <p class="m-0 p-0">{{ item.nome }}</p>
                    </th>

                    <th>
                      <p class="m-0 p-0">{{ item.dataInicial }}</p>
                    </th>

                    <th>
                      <p class="m-0 p-0">{{ item.dataFinal }}</p>
                    </th>

                    <th>
                      <p class="m-0 p-0">{{ item.status }}</p>
                    </th>

                    <th>
                      <p class="m-0 p-0">{{ item.dataGeracao }}</p>
                    </th>

                    <th>
                      <p class="m-0 p-0">{{ item.dataAssinatura }}</p>
                    </th>

                    <th>
                      <el-tooltip
                        content="Visualizar Assinatura"
                        effect="light"
                        :open-delay="300"
                        placement="top"
                      >
                        <base-button
                          @click.native="selecionarAssinatura(item)"
                          class="edit btn-link"
                          type="info"
                          size="sm"
                          icon
                        >
                          <i class="tim-icons icon-notes"></i>
                        </base-button>
                      </el-tooltip>
                    </th>
                  </tr>

                  <tr v-if="!dados.length && !isLoading">
                    <td colspan="7" class="text-center">
                      Nenhuma assinatura encontrada.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação -->
            <Paginacao
              v-show="!printing && pagination.totalPages > 1"
              :currentPage="pagination.currentPage"
              :totalPages="pagination.totalPages"
              @page-changed="listarAssinaturas"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { Card, BaseFiltroRelatorio, Paginacao } from "@/components/index";

import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
    BaseFiltroRelatorio,
    Paginacao,
  },

  data() {
    return {
      isLoading: false,
      dados: [],
      tela: 1,
      printing: false,
      payloadPesquisa: {},
      assinaturaSelecionado: null,

      pagination: {
        currentPage: 1,
        perPage: 50,
        totalItems: 0,
        totalPages: 0,
      },
    };
  },

  methods: {
    moment(data) {
      return moment(data);
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title,
          text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    pesquisar(event) {
      this.payloadPesquisa = event;
      this.listarAssinaturas(1);
    },

    async listarAssinaturas(page = 1) {
      this.isLoading = true;

      const payload = {
        ...this.payloadPesquisa,
        setDB: this.$cookies.get("db"),
        page,
        limit: this.pagination.perPage,
      };

      try {
        const response = await this.axios.post(
          "/api/relatorio/listarAssinaturas",
          payload,
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        if (!response.data.status) {
          throw new Error("A API não retornou sucesso.");
        }

        const resultado = response.data.data;

        this.dados = resultado.assinaturas || [];
        this.pagination = resultado.pagination;
        this.tela = 2;
      } catch (error) {
        console.error("Erro ao buscar assinaturas:", error);

        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao buscar as assinaturas.",
          "error",
        );
      } finally {
        this.isLoading = false;
      }
    },

    async selecionarAssinatura(row) {
      this.assinaturaSelecionado = row;
      await this.listarDocumentos();
    },

    async listarDocumentos() {
      this.isLoading = true;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.assinaturaSelecionado.id,
      };

      try {
        const response = await this.axios.post(
          "/api/assinaturasPonto/listarDocumentosPorFuncionario",
          bodyFormData,
        );

        if (!response.data.data) {
          throw new Error("Documentos não encontrados.");
        }

        const documentos = response.data.data;

        this.assinaturaSelecionado = {
          ...this.assinaturaSelecionado,
          arquivoAssinado: documentos.arquivoAssinado,
          arquivoOriginal: documentos.arquivoOriginal,
        };

        const arquivo =
          this.assinaturaSelecionado.arquivoAssinado ||
          this.assinaturaSelecionado.arquivoOriginal;

        if (!arquivo) {
          throw new Error("Nenhum arquivo disponível.");
        }

        this.abrirPdf(arquivo);
      } catch (error) {
        console.error("Erro ao listar documentos:", error);

        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao listar documentos!",
          "error",
        );
      } finally {
        this.isLoading = false;
      }
    },

    base64ToArrayBuffer(data) {
      const bString = window.atob(data);
      const bytes = new Uint8Array(bString.length);

      for (let i = 0; i < bString.length; i++) {
        bytes[i] = bString.charCodeAt(i);
      }

      return bytes;
    },

    abrirPdf(data) {
      const bufferArray = this.base64ToArrayBuffer(data);
      const blobStore = new Blob([bufferArray], {
        type: "application/pdf",
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
      }

      const url = window.URL.createObjectURL(blobStore);
      const link = document.createElement("a");

      document.body.appendChild(link);
      link.href = url;
      link.download = "file.pdf";
      link.click();

      window.URL.revokeObjectURL(url);
      link.remove();
    },

    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
  },
};
</script>

<style></style>
